/**
 * Model odpowiedzi API (DTO) dostarczający kod i instrukcję
 * widżetu Vetineo danej lecznicy weterynaryjnej.
 */
export class WidgetResponse {

  /** * Surowy kod widżetu do osadzenia.
   */
  public widget: string;

  /** Treść instrukcji skorzystania z Vetineo w danej lecznicy
   */
  public instruction: string;

  /** Skrót kryptograficzny (Hash) obecnej wersji widżetu.
   */
  public widgetHash: string;

}
